import { fabric } from 'fabric';
import AnalyticsBehaviors from './AnalyticsBehaviors';
import CollaborationBehaviors from './CollaborationBehaviors';
import ReadOnlyBehaviors from './ReadOnlyBehaviors';
import SmartGuideBehaviors from './SmartGuideBehaviors';
import ExternalContentBehaviors from '../objects/ExternalContentBehaviors';
import LockBehaviors from './LockBehaviors';
import CommentableBehaviors from './CommentableBehaviors';
import trackEvent from '../utils/analytics';
import FrameMemberBehaviors from './FrameMemberBehaviors';
import EmbeddedContentBehaviors, {
  type EmbeddedContentBehaviorsInterface,
} from './EmbeddedContentBehaviors';

interface EmbeddedBookmark
  extends fabric.Object,
    ReadOnlyBehaviors,
    SmartGuideBehaviors,
    CollaborationBehaviors,
    LockBehaviors,
    CommentableBehaviors,
    FrameMemberBehaviors,
    EmbeddedContentBehaviorsInterface {}

@AnalyticsBehaviors
@ReadOnlyBehaviors
@ExternalContentBehaviors
@SmartGuideBehaviors
@CollaborationBehaviors
@LockBehaviors
@CommentableBehaviors
@FrameMemberBehaviors
@EmbeddedContentBehaviors
class EmbeddedBookmark extends fabric.Object {
  type = 'embeddedBookmark';

  bookmarkId: string;

  serializedKeys = ['bookmarkId'];

  constructor(options) {
    super(options);

    this.initializeLockBehaviors(options.locked);
    this.initializeSmartGuides();
    this.initializeFrameMember();
    this.initializeEmbeddedContentBehaviors();
  }

  get bookmarkUrl() {
    return `/bookmarks/${this.bookmarkId}.publish?disable_link_filtering=true`;
  }

  get externalContentUrl() {
    return this.bookmarkUrl;
  }

  protected get interactionMessage() {
    return 'Double click to interact with the view';
  }

  protected onBeginInteraction() {
    trackEvent(
      'Feature-7226844293821880091',
      'User interacts with whiteboard view'
    );
  }
}

export default EmbeddedBookmark;
